import { render, staticRenderFns } from "./OutputFieldTextBase.vue?vue&type=template&id=405135e3&scoped=true&"
import script from "./OutputFieldTextBase.vue?vue&type=script&lang=ts&"
export * from "./OutputFieldTextBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405135e3",
  null
  
)

export default component.exports